import { useMemo } from "react";
import {
  DocumentStages,
  DocumentStatus,
  InsuranceDocument,
} from "../../../graphql/__GENERATED__/types";
import Card, { CardFC } from "../../../components/CardList/components/Card";
import Icon from "../../../components/Icons";
import { cardDocumentStatusFilters } from "../../../filters/documents";
import Responsibles from "./components/Responsibles";
import useDocumentColor from "../../../hooks/useDocumentColor";
import Tooltip from "../../../components/Tooltip";
import { statusLabel } from "../DocumentDetails/sections/Summary/components/StageAndStatusLabels";
import { formatISODate } from "../../../utils/formatNumber";

const DocumentCard: CardFC<InsuranceDocument> = ({ data, active, onClick }) => {
  const cardData = useMemo(
    () => ({
      line1: data.farmer?.name || "",
      line2: data.crop?.culture
        ? `${data.crop?.cultureName} ${
            data.crop?.area && "//" + data.crop?.area + " ha"
          }`
        : "",
      line3: data.property?.address?.city
        ? `${data.property.address.city} ${
            data.property?.address?.state && "//" + data.property.address.state
          }`
        : "",
      line4: formatISODate(data.createdAt) || "",
    }),
    [data]
  );

  const cardColor = useDocumentColor(data.stage as DocumentStages);
  const statusIcon = () => {
    return cardDocumentStatusFilters().find(
      (option) => option.filter.status === data.status
    )?.iconName;
  };

  const responsibles = useMemo(() => {
    return [
      data.originator?.nome || "",
      data.commercialResponsible?.nome || "",
      data.operationalResponsible?.nome || "",
    ];
  }, [data]);

  const detailTopRight = useMemo(() => {
    return (
      <Tooltip
        text={statusLabel[data.status! as DocumentStatus]}
        id={`status-${data._id!}`}
      >
        <Icon name={statusIcon()!} color={cardColor} />
      </Tooltip>
    );
  }, [data.status, cardColor, data._id]);

  return (
    <Card
      cardData={cardData}
      detailTop={detailTopRight}
      detailBottom={
        <Responsibles
          responsibles={responsibles}
          color={cardColor}
          docId={data._id!}
        />
      }
      color={cardColor}
      active={active}
      onClick={onClick}
    />
  );
};

export default DocumentCard;
